import { getBlockType } from "@pathwright/blocks-core"
import {
  BlockCompletionProvider,
  BlockValidationIndicator,
  useBlocksConfig
} from "@pathwright/blocks-engine"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import classnames from "classnames"
import { memo, useMemo } from "react"
import styled from "styled-components"
import BlockWrap from "../block/BlockWrap"
import { getBlock } from "../block/utils"

const requiresInternetConection = (blockType) => {
  // For now this is any type of progress tracking block but that may not be the case
  // in the future
  return typeof blockType.resolveUserCompletion === "function"
}

const ReadOnlyOverlay = styled.div`
  width: 100%;
  height: 100%;
  left: 0px;
  padding: 10px;
  top: 0px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 16px;
  color: #fff;
  border-bottom: 1px solid #000;
  background-color: rgba(0, 0, 0, 0.66);
`

const propsAreEqual = (prevProps, nextProps) => {
  if (prevProps.completion !== nextProps.completion) return false
  if (prevProps.blockIndex !== nextProps.blockIndex) return false
  if (prevProps.block !== nextProps.block) return false

  return true
}

const BlockViewer = memo((props) => {
  const { block, onChange, blockIndex } = props

  const { completion, type, layout, id, style, data } = block

  const { offline } = useBlocksConfig()

  const blockType = useMemo(() => getBlockType(type), [type])
  const Block = useMemo(() => getBlock(type, "view"), [type])

  const handleChange = (dataChange, trackProgress = false) => {
    const nextData = { ...data, ...dataChange }
    onChange(id, nextData, trackProgress)
  }

  // TODO: return a loading skeleton here
  if (!Block) return <div />

  const readOnly = offline && requiresInternetConection(blockType)

  // very temporary and brittle solution for custom styling
  const className = classnames(
    "ContentBlock",
    `ContentBlockType-${type}`,
    `ContentBlockLayout-${layout}`
  )

  const blockCompletionClass =
    completion && completion.progress !== null
      ? completion.progress
        ? " block-completed"
        : " block-incomplete"
      : ""

  return (
    <BlockCompletionProvider completion={completion} data={data}>
      <BlockWrap
        className={`Block-${blockIndex}${blockCompletionClass}`}
        styledColor={style?.styleAttributes.color}
        style={{
          ...(style?.styleAttributes || {}),
          transition: "all 0.5s"
        }}
        block={block}
      >
        <BlockValidationIndicator />
        <Block
          className={className}
          onChange={handleChange}
          layout={layout}
          completion={completion}
          blockType={blockType}
          readOnly={readOnly}
          id={id}
          data={data}
          blockStyles={style}
        />
        {readOnly ? (
          <ReadOnlyOverlay>
            <Pathicon icon="lock" style={{ fontSize: 24 }} />
            <p>Please connect to the internet to access this content.</p>
          </ReadOnlyOverlay>
        ) : null}
      </BlockWrap>
    </BlockCompletionProvider>
  )
}, propsAreEqual)

BlockViewer.displayName = "BlockViewer"

export default BlockViewer
